// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"455":"91a01697","977":"5cc2826a"}[chunkId] + ".chunk.js";
};